class CountdownHomepage extends HTMLElement {
  constructor() {
    super();
    this.startDate = null;
    this.finishDate = null;
    this.timerEl = null;
    this.intervalId = null;
    this.days = null;
    this.hours = null;
    this.minutes = null;
    this.seconds = null;
  }

  connectedCallback() {


    // Grab the inner countdown container
    const countdownContainer = this.querySelector("#countdown");
    if (!countdownContainer) return;

    // Read dataset
    const startAttr = countdownContainer.dataset.startDate;
    const finishAttr = countdownContainer.dataset.finishDate;

    // Parse dates
    this.startDate = this.parseDate(startAttr);
    this.finishDate = this.parseDate(finishAttr);

    // Grab timer display element
    this.timerEl = countdownContainer.querySelector(".shop-timer");

    // Grab days minutes hours and seconds html elements
    this.days = countdownContainer.querySelector(".days");
    this.hours = countdownContainer.querySelector(".hours");
    this.minutes = countdownContainer.querySelector(".minutes");
    this.seconds = countdownContainer.querySelector(".seconds");

    // Start countdown
    this.startCountdown();
  }

  parseDate(dateStr) {
    // Expect MM/DD/YYYY or MM/DD (fallback to current year)
    const parts = dateStr.split("/");
    const month = parseInt(parts[0], 10);
    const day = parseInt(parts[1], 10);
    const year = parts[2] ? parseInt(parts[2], 10) : new Date().getFullYear();

    return new Date(year, month - 1, day, 0, 0, 0); // midnight that day
  }

  pad(num) {
    return String(num).padStart(2, "0");
  }

  startCountdown() {
    if (!this.startDate || !this.finishDate || !this.timerEl) return;

    const update = () => {
      const now = new Date();

      if (now < this.startDate) {
        this.timerEl.textContent = "Countdown hasn’t started yet";
        return;
      }

      if (now > this.finishDate) {
        this.timerEl.textContent = "";
        clearInterval(this.intervalId);
        return;
      }

      const diff = this.finishDate - now;
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const mins = Math.floor((diff / (1000 * 60)) % 60);
      const secs = Math.floor((diff / 1000) % 60);

      if (this.days) {
        const spans = this.days.querySelectorAll("span");
        spans[0].textContent = this.pad(days);
        spans[1].textContent = days === 1 ? "Day" : "Days";
      }

      if (this.hours) {
        const spans = this.hours.querySelectorAll("span");
        spans[0].textContent = this.pad(hours);
        // spans[1] is static "Hrs" so we leave it
      }

      if (this.minutes) {
        const spans = this.minutes.querySelectorAll("span");
        spans[0].textContent = this.pad(mins);
        // spans[1] is static "Min"
      }

      if (this.seconds) {
        const spans = this.seconds.querySelectorAll("span");
        spans[0].textContent = this.pad(secs);
        // spans[1] is static "Sec"
      }
    };

    update();
    this.intervalId = setInterval(update, 1000);
  }
}

if (!customElements.get("countdown-homepage")) {
  customElements.define("countdown-homepage", CountdownHomepage);
}
